import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Initializes Lenis smooth scroll once at the app root. Disables itself
 * automatically on coarse-pointer devices (mobile) where momentum scrolling
 * already feels great natively.
 */
export default function LenisScroller() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const isCoarse = window.matchMedia("(hover: none)").matches;
    if (isCoarse) return;

    const lenis = new Lenis({
      duration: 1.05,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });
    // Expose for ScrollToTop and other consumers
    window.__lenis = lenis;

    let raf;
    const tick = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      if (window.__lenis === lenis) delete window.__lenis;
    };
  }, []);

  return null;
}
